import React from 'react';
import { useSelector } from 'react-redux';

export default function useCustomerSelector() {
  const CustomerListData = useSelector((state) => state.Customer.list_data) || []; // List data
  const CustomerViewData = useSelector((state) => state.Customer.view_data) || []; // view data

  return { CustomerListData, CustomerViewData };
}
